(function () {
  'use strict';

  /* Inject styles */
  var style = document.createElement('style');
  style.textContent = [
    '.thp-rv {',
    '  opacity: 0;',
    '  transform: translateY(24px);',
    '  transition: opacity 0.7s cubic-bezier(0.22, 0.61, 0.36, 1),',
    '              transform 0.7s cubic-bezier(0.22, 0.61, 0.36, 1);',
    '  will-change: opacity, transform;',
    '}',
    '.thp-rv.in { opacity: 1; transform: translateY(0); }',
    '',
    '.thp-sg > * {',
    '  opacity: 0;',
    '  transform: translateY(16px);',
    '  transition: opacity 0.5s cubic-bezier(0.22, 0.61, 0.36, 1),',
    '              transform 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);',
    '  will-change: opacity, transform;',
    '}',
    '.thp-sg.in > * { opacity: 1; transform: translateY(0); }',
    '.thp-sg.in > *:nth-child(1) { transition-delay: 0ms; }',
    '.thp-sg.in > *:nth-child(2) { transition-delay: 60ms; }',
    '.thp-sg.in > *:nth-child(3) { transition-delay: 120ms; }',
    '.thp-sg.in > *:nth-child(4) { transition-delay: 180ms; }',
    '.thp-sg.in > *:nth-child(5) { transition-delay: 240ms; }',
    '.thp-sg.in > *:nth-child(6) { transition-delay: 300ms; }',
    '.thp-sg.in > *:nth-child(7) { transition-delay: 360ms; }',
    '.thp-sg.in > *:nth-child(8) { transition-delay: 420ms; }',
    '',
    'html { scroll-behavior: smooth; }',
    '',
    '@media (prefers-reduced-motion: reduce) {',
    '  .thp-rv, .thp-sg > * {',
    '    opacity: 1 !important;',
    '    transform: none !important;',
    '    transition: none !important;',
    '  }',
    '  html { scroll-behavior: auto; }',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  /* Bail on browsers without IntersectionObserver */
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var sections = document.querySelectorAll('[id^="shopify-section-"]');

    sections.forEach(function (section) {
      /* Skip explicit opt-outs */
      if (section.getAttribute('data-thp-reveal') === 'off') return;

      /* Skip headers and footers — they should always be visible */
      var first = section.firstElementChild;
      if (first && (first.tagName === 'HEADER' || first.tagName === 'FOOTER')) return;

      /* Skip if the section directly contains a custom header class */
      if (section.querySelector('.thp-header-section')) return;

      section.classList.add('thp-rv');

      /* Auto-detect grid containers for stagger */
      var grids = section.querySelectorAll(
        '.thp-fc__track, .thp-blog__grid, .thp-life__images, ' +
        '[class*="__grid"], [class*="-grid"], .product-grid, ' +
        '.collection-list, .multicolumn-list'
      );
      grids.forEach(function (grid) {
        var count = grid.children.length;
        if (count >= 2 && count <= 10 && !grid.hasAttribute('data-thp-no-stagger')) {
          grid.classList.add('thp-sg');
        }
      });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        entry.target.querySelectorAll('.thp-sg').forEach(function (g) {
          g.classList.add('in');
        });
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.05
    });

    document.querySelectorAll('.thp-rv').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when sections are added/reordered in the theme editor */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target;
      if (sec.getAttribute('data-thp-reveal') === 'off') return;
      var first = sec.firstElementChild;
      if (first && (first.tagName === 'HEADER' || first.tagName === 'FOOTER')) return;
      if (sec.querySelector('.thp-header-section')) return;
      sec.classList.add('thp-rv', 'in');
      sec.querySelectorAll(
        '.thp-fc__track, .thp-blog__grid, .thp-life__images, ' +
        '[class*="__grid"], [class*="-grid"], .product-grid'
      ).forEach(function (g) {
        if (g.children.length >= 2 && g.children.length <= 10) {
          g.classList.add('thp-sg', 'in');
        }
      });
    });
  }
})();